module.exports = __webpack_public_path__ + "assets/expedia-logo-gs.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/expedia-logo-gs.png
// module id = 1213
// module chunks = 7